// CHC (Certidao de Habilitacao de Credito): status, ramos da justica e documentos.
export const statuses = [
    { id: "pending", name: "Pendente", tone: "warning" },
    { id: "in_analysis", name: "Em análise", tone: "info" },
    { id: "documents_requested", name: "Docs. solicitados", tone: "purple" },
    { id: "documents_updated", name: "Docs. atualizados", tone: "teal" },
    { id: "outdated", name: "Desatualizada", tone: "neutral" },
    { id: "approved", name: "Aprovada", tone: "success" },
    { id: "rejected", name: "Rejeitada", tone: "danger" },
];

export const justiceBranches = [
    { id: "trabalho", name: "Justiça do Trabalho" },
    { id: "estadual", name: "Justiça Estadual" },
    { id: "federal", name: "Justiça Federal" },
    { id: "outra", name: "Outra" },
];

export const requesterTypes = [
    { id: "creditor", name: "Credor" },
    { id: "procurator", name: "Procurador" },
];

export const documentKinds = [
    { id: "chc", name: "Certidão de Habilitação de Crédito (CHC)" },
    { id: "full_process", name: "Processo completo" },
    { id: "calculation_decision", name: "Decisão homologatória de cálculo" },
    { id: "calculation_sheet", name: "Planilha de cálculos" },
];

export const nameOf = (list, id) => {
    const item = list.find((entry) => entry.id === id);
    return item ? item.name : (id || "—");
};

export const toneOf = (list, id) => {
    const item = list.find((entry) => entry.id === id);
    return item && item.tone ? item.tone : "neutral";
};
